export const CookieUtils = {
  setCookie (name, value, minutes = 0) {
    const date = new Date()
    if (minutes) {
      date.setTime(date.getTime() + minutes * 60 * 1000)
    }
    const expires = minutes ? 'expires=' + date.toUTCString() : ''
    document.cookie = `${name}=${value};${expires};path=/`
  },

  getCookie (name) {
    const nameEQ = name + '='
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim()
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length)
      }
    }
    return null
  },

  isExportInProgress (cookieName) {
    const cookieValue = this.getCookie(cookieName)
    return cookieValue === 'true'
  },

  startExport (cookieName) {
    this.setCookie(cookieName, 'true', 25)
  },

  completeExport (cookieName) {
    this.setCookie(cookieName, 'false', 25)
  }
}



// WEBPACK FOOTER //
// ./src/shared/utils/cookiesUtils.js